import type { Logger } from "@expert/logging";

import { getSalesApiClient } from "./api";

export const fetchAddressSuggestions = async (logger: Logger, searchText: string) => {
    const childLogger = logger.child({ module: "addressSuggestions" });
    if (searchText.length < 6) return [];
    try {
        const salesApi = getSalesApiClient();
        const sanitizedSearchText = encodeURIComponent(searchText);
        const addresses = await salesApi.get(`v1/address-autocomplete?text=${sanitizedSearchText}`).json<string[]>();

        return Array.from(new Set(addresses));
    } catch (error: unknown) {
        childLogger.warn({ error }, "addressSuggestions failure");
        throw error;
    }
};
